import type { Office } from "@homeinstead/schemas";
import type { FooterColumnContentProps } from "../../../types/footer-columns";

import React from "react";
import { FooterColumnContent } from "./FooterColumnContent";

type FooterPlainColumnProps = {
  title: string;
  items: Omit<FooterColumnContentProps, "placeholders" | "office">[];
  /** Placeholder values for dynamic content */
  placeholders?: FooterColumnContentProps["placeholders"];
  /** Office document for social media links */
  office?: Office;
};

const FooterPlainColumn = ({
  title,
  items,
  placeholders,
  office,
}: FooterPlainColumnProps) => {
  return (
    <div className="plain-footer-column mb-8">
      <h3 className="mb-2 font-bold text-new-beginnings-base leading-tight">
        {title}
      </h3>
      <div className="text-sm leading-6 [&_a]:text-sm">
        {items.map((item) => (
          <FooterColumnContent
            key={item._key}
            office={office}
            placeholders={placeholders}
            {...item}
          />
        ))}
      </div>
    </div>
  );
};

export { FooterPlainColumn };
